/*
 * Migration Lot 4 (2026-04-30) : remplace `@mui/material/Tabs` par
 * shadcn/ui (Radix Tabs). API publique inchangée — `TabsIndex(props)`
 * passe `props` aux deux enfants TabOne / TabTwo.
 *
 * Choix visuel : variante "underline" (soulignement actif) plutôt que
 * la variante "pill" par défaut de shadcn — meilleure lisibilité avec
 * les labels longs et continuité visuelle avec l'ancien rendu MUI.
 * Implémentée via override className sur TabsList + TabsTrigger ; la
 * primitive shadcn `<TabsList>` n'est pas modifiée.
 */
import * as React from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import TabOne from "./TabOne";
import TabTwo from "./TabTwo";

// Underline variant : annule le fond pill et la radius shadcn par défaut,
// soulignement bottom de 2px qui passe en couleur primary à l'activation.
const tabsListClass =
  "bg-transparent p-0 h-auto w-full justify-start gap-2 rounded-none border-b";
const tabsTriggerClass =
  "rounded-none border-b-2 border-transparent px-4 py-2 -mb-px " +
  "data-[state=active]:border-primary data-[state=active]:bg-transparent " +
  "data-[state=active]:shadow-none";

export default function TabsIndex(props) {
  return (
    // `defaultValue` reproduit l'ancien `useState(0)` (premier tab actif au
    // mount). Mode uncontrolled : aucun parent n'observait l'index courant.
    <Tabs defaultValue="pharmacy" className="w-full">
      <TabsList className={tabsListClass}>
        <TabsTrigger value="pharmacy" className={tabsTriggerClass}>
          Pharmacie
        </TabsTrigger>
        <TabsTrigger value="sales" className={tabsTriggerClass}>
          Suivie de vente
        </TabsTrigger>
      </TabsList>

      {/*
        Radix `TabsContent` ne monte ses enfants que quand le tab est actif
        (sauf `forceMount`) — comportement identique à l'ancien `TabPanel`
        qui rendait `{value === index && children}`. La perte d'état au
        switch (formulaires non préservés) est donc inchangée.
        `p-6` reproduit l'ancien `Box sx={{ p: 3 }}` (theme.spacing(3) ≈ 24px).
      */}
      <TabsContent value="pharmacy" className="p-6">
        <TabOne {...props} />
      </TabsContent>
      <TabsContent value="sales" className="p-6">
        <TabTwo {...props} />
      </TabsContent>
    </Tabs>
  );
}
